import styled from "styled-components";
import { BORDER_SECONDARY } from "../../config/Constants";


export const HrSecondary = styled.hr`
  border: 1px solid ${BORDER_SECONDARY};
`
